export default __webpack_public_path__ + "static/media/Tourist in Olympe.b781b689.jpg";